import moment from "moment";

import store from "../store";
import http from "../http-common";

http.interceptors.request.use(function (config) {
  config.headers.token = store.getters.token;
  return config;
});

class SurveyDataService {
  getAll() {
    return http.get("/surveys");
  }

  getSurvey(id) {
    return http.get(`/surveys/${id}`);
  }

  create(data) {
    return http.post("/surveys", data);
  }

  delete(id) {
    return http.delete(`/surveys/${id}`);
  }

  findByName(inputText) {
    return http.get(`/surveys/search/?t=${inputText}`);
  }

  getCsv(id) {
    return http.get(`/surveys/${id}/datasets/csv`);
  }

  getJson(id) {
    return http.get(`/surveys/${id}/datasets`);
  }

  getResultsCsv(id) {
    return http.get(`/surveys/${id}/datasets/results/csv`);
  }

  getResultsJson(id) {
    return http.get(`/surveys/${id}/datasets/results/json`);
  }

  assignSurvey(sid, uid, expireAfterPublishMinutes) {
    return http.post(`/users/${uid}/surveys/${sid}/${expireAfterPublishMinutes}`);
  }

  scheduleSurveyOnce(sid, uid, publishAt, expireAfterPublishMinutes) {
    // alert("publishAt: '" + moment(publishAt.format("YYYY-MM-DD HH:mm")) + "'.");
    if (!moment(publishAt).isValid()) {
      alert("publishAt not valid: '" + publishAt + "'.");
      return;
    }

    var publishAtMillis = moment(publishAt).utc().unix();
    return http.post(`/users/${uid}/schedule/survey/${sid}/${publishAtMillis}/${expireAfterPublishMinutes}`);
  }

  scheduleSurveySeries(sid, uid, gid, startYMD, endYMD, scheduleHMs, plusMinusRandomMinutes, expireAfterPublishMinutes) {

    if ((uid && gid) || (!uid && !gid)) {
      alert("please select either user or group");
      return;
    }

    if (!moment(startYMD).isValid()) {
      alert("publishAt not valid: '" + startYMD + "'.");
      return;
    }
    if (!moment(endYMD).isValid()) {
      alert("publishAt not valid: '" + endYMD + "'.");
      return;
    }

    // var startDateUtcUnix = moment(startYMD).unix();
    // var endDateUtcUnix = moment(endYMD).unix();

    // alert(startDate);
    // alert(moment(startDate));
    // alert(moment(startDate).unix());
    // alert(moment(startDate).format('X'));

    // alert(moment(startDate).format("YYYY-MM-DD"));
    // alert(moment(startDate).unix().format("YYYY-MM-DD"));
    
    const hoursString = scheduleHMs.join("+");
    
    if (uid) {
      return http.post(`/users/${uid}/schedule/survey/${sid}/${startYMD}/${endYMD}/${hoursString}/${plusMinusRandomMinutes}/${expireAfterPublishMinutes}`);
    } else if (gid) {
      return http.post(`/groups/${gid}/schedule/survey/${sid}/${startYMD}/${endYMD}/${hoursString}/${plusMinusRandomMinutes}/${expireAfterPublishMinutes}`);
    }
  }
}

export default new SurveyDataService();
